export const esTranslations = {
  header: {
    home: 'Inicio',
    tattooDesign: 'Diseño de Tatuajes',
    nailDesign: 'Diseño de Uñas',
    gallery: 'Galería',
    about: 'Acerca de',
    signIn: 'Iniciar Sesión',
    signOut: 'Cerrar Sesión',
    profile: 'Perfil'
  },
  hero: {
    tattooSlide: {
      title: 'Diseños de Tatuajes con IA',
      description: 'Crea diseños únicos de tatuajes en segundos con nuestra avanzada tecnología de IA'
    },
    nailSlide: {
      title: 'Arte de Uñas Impresionante',
      description: 'Genera hermosos diseños de arte para uñas personalizados a tu estilo'
    },
    tryNow: 'Prueba Ahora',
    viewGallery: 'Ver Galería'
  },
  home: {
    features: {
      title: 'Libera tu Creatividad con IA',
      subtitle: 'Genera diseños únicos de tatuajes y uñas en segundos con nuestra avanzada tecnología de IA',
      aiPowered: {
        title: 'Diseño Impulsado por IA',
        description: 'Nuestra IA de vanguardia analiza miles de diseños profesionales para generar obras de arte únicas y personalizadas para tatuajes y arte de uñas.'
      },
      unlimitedStyles: {
        title: 'Estilos Ilimitados',
        description: 'Desde arte lineal minimalista hasta acuarelas vibrantes, crea diseños en cualquier estilo que puedas imaginar tanto para tatuajes como para arte de uñas.'
      },
      completelyFree: {
        title: 'Completamente Gratis',
        description: 'Genera tantos diseños como quieras sin ningún costo. Nuestra plataforma es compatible con anuncios no intrusivos.'
      }
    },
    featuredDesigns: {
      title: 'Diseños Destacados',
      viewAll: 'Ver todos los diseños →'
    },
    cta: {
      title: '¿Listo para Crear tu Diseño Soñado?',
      subtitle: 'Comienza a generar diseños únicos de tatuajes y arte de uñas en segundos con nuestra tecnología de IA.',
      createTattoo: 'Crear Diseño de Tatuaje',
      createNail: 'Crear Diseño de Uñas'
    }
  },
  tattoo: {
    title: 'Crea tu Diseño de Tatuaje Perfecto',
    subtitle: 'Utiliza nuestra IA para generar diseños de tatuajes únicos y personalizados en segundos',
    generator: {
      title: 'Crea tu Diseño de Tatuaje',
      describePrompt: 'Describe tu diseño de tatuaje soñado',
      placeholder: 'Ej., Un tatuaje de lobo geométrico minimalista con salpicaduras de acuarela en azul y morado...',
      styleOptions: 'Estilo de Tatuaje',
      colorOptions: 'Opciones de Color',
      bodyPartOptions: 'Ubicación en el Cuerpo',
      styleDescription: 'Tradicional, minimalista, acuarela, tribal, geométrico...',
      uploadReference: 'Subir Referencia',
      uploadDescription: 'Añade una imagen de referencia para guiar a la IA',
      generate: 'Generar Diseños',
      generating: 'Generando...',
      advancedOptions: 'Opciones Avanzadas',
      recentDesigns: 'Diseños Recientes',
      design: 'Diseño #',
      languageTip: 'Para mejores resultados, usa inglés al describir tu tatuaje. El modelo de IA funciona mejor con indicaciones en inglés.'
    },
    noDesignsYet: {
      title: 'Aún no hay diseños de tatuajes',
      description: 'Ingresa una descripción arriba y haz clic en "Generar Diseños" para crear tu diseño de tatuaje personalizado.'
    },
    styles: {
      title: 'Estilos Populares de Tatuajes',
      traditional: '• Tradicional/Old School - Líneas gruesas y colores vibrantes',
      minimalist: '• Minimalista - Diseños limpios y simples con líneas finas',
      geometric: '• Geométrico - Patrones y formas con precisión matemática',
      watercolor: '• Acuarela - Diseños vibrantes y fluidos que se asemejan a la pintura de acuarela',
      blackwork: '• Blackwork - Diseños en tinta negra con fuerte contraste',
      tribal: '• Tribal - Patrones antiguos inspirados en culturas indígenas'
    },
    tips: {
      title: 'Cómo Obtener el Diseño Perfecto',
      specific: {
        title: 'Se específico',
        description: 'Incluye estilo, elementos, colores y tamaño en tu descripción'
      },
      references: {
        title: 'Sube referencias',
        description: 'Proporciona imágenes que te inspiren para obtener resultados más precisos'
      },
      variations: {
        title: 'Prueba variaciones',
        description: 'Genera múltiples diseños con pequeños cambios en las instrucciones'
      },
      consult: {
        title: 'Consulta con un artista',
        description: 'Siempre haz que un tatuador profesional revise tu diseño'
      }
    }
  },
  nail: {
    title: 'Crea Impresionantes Diseños de Arte para Uñas',
    subtitle: 'Utiliza nuestra IA para generar hermosos diseños de uñas a la moda en segundos',
    generator: {
      title: 'Crea tu Diseño de Arte para Uñas',
      describePrompt: 'Describe tu diseño soñado de arte para uñas',
      placeholder: 'Ej., Diseño de uñas temático de galaxia con estrellas y degradado de púrpura a azul...',
      styleOptions: 'Opciones de Estilo',
      colorOptions: 'Opciones de Color',
      bodyPartOptions: 'Ubicación en el Cuerpo',
      styleDescription: 'Francés, degradado, gel, acrílico, mate, brillante...',
      uploadReference: 'Subir Referencia',
      uploadDescription: 'Añade una imagen de referencia para guiar a la IA',
      generate: 'Generar Diseños',
      generating: 'Generando...',
      advancedOptions: 'Opciones Avanzadas',
      recentDesigns: 'Diseños Recientes',
      design: 'Diseño #',
      languageTip: 'Para mejores resultados, usa inglés al describir tu diseño de uñas. El modelo de IA funciona mejor con indicaciones en inglés.'
    },
    noDesignsYet: {
      title: 'Aún no hay diseños de uñas',
      description: 'Ingresa una descripción arriba y haz clic en "Generar Diseños" para crear tu diseño de arte para uñas personalizado.'
    },
    styles: {
      title: 'Estilos Populares de Arte para Uñas',
      french: '• Francés - Puntas blancas clásicas con base natural',
      ombre: '• Degradado - Efecto gradiente de un color a otro',
      gel: '• Gel - Diseños brillantes y duraderos con esmalte en gel',
      threeD: '• Arte 3D - Diseños con textura con elementos añadidos',
      minimalist: '• Minimalista - Diseños simples y limpios con líneas finas',
      rhinestone: '• Pedrería - Diseños brillantes con acentos de cristal'
    },
    tips: {
      title: 'Consejos para Arte de Uñas',
      shape: {
        title: 'Considera la forma de las uñas',
        description: 'Diferentes diseños funcionan mejor en uñas cuadradas, ovaladas, almendradas o stiletto'
      },
      color: {
        title: 'Armonía de colores',
        description: 'Elige colores que complementen tu tono de piel y vestuario'
      },
      seasonal: {
        title: 'Tendencias estacionales',
        description: 'Considera las tendencias actuales y los colores de temporada para diseños oportunos'
      },
      professional: {
        title: 'Aplicación profesional',
        description: 'Para diseños complejos, considera que una manicurista profesional los aplique'
      }
    }
  },
  gallery: {
    title: 'Galería de Diseños',
    subtitle: 'Explora nuestra colección de diseños de tatuajes y arte de uñas generados por IA',
    search: 'Buscar diseños...',
    filters: {
      all: 'Todos',
      tattoos: 'Tatuajes',
      nailArt: 'Arte de Uñas'
    },
    noResults: {
      title: 'No se encontraron diseños',
      subtitle: 'Intenta ajustar tu búsqueda o filtros'
    }
  },
  about: {
    title: 'Acerca de TattooNailGenius',
    subtitle: 'Revolucionando el diseño de tatuajes y arte de uñas con tecnología de IA',
    mission: {
      title: 'Nuestra Misión',
      paragraph1: 'En TattooNailGenius, nuestra misión es democratizar el diseño artístico haciendo accesibles los tatuajes personalizados y el arte de uñas para todos. Creemos que la expresión personal a través del arte corporal debe estar disponible para todos, independientemente de su capacidad artística o restricciones presupuestarias.',
      paragraph2: 'Al aprovechar el poder de la inteligencia artificial, hemos creado una plataforma que cierra la brecha entre la imaginación y la visualización, ayudando a las personas a dar vida a sus ideas creativas antes de tomar decisiones permanentes sobre su arte corporal.'
    },
    values: {
      title: 'Nuestros Valores',
      creativity: {
        title: 'Creatividad',
        description: 'Creemos en potenciar la creatividad y la autoexpresión a través de tecnología innovadora, ayudando a los usuarios a visualizar sus ideas con un detalle impresionante.'
      },
      innovation: {
        title: 'Innovación',
        description: 'Continuamente ampliamos los límites de la tecnología de IA para crear opciones de diseño más realistas, diversas y personalizadas para nuestros usuarios.'
      },
      accessibility: {
        title: 'Accesibilidad',
        description: 'Creemos que todos deberían tener acceso a herramientas de diseño de calidad sin barreras financieras, por eso nuestra plataforma es gratuita y está respaldada por anuncios no intrusivos.'
      },
      community: {
        title: 'Comunidad',
        description: 'Fomentamos una comunidad de apoyo donde artistas, entusiastas y clientes pueden conectarse, compartir diseños y brindarse retroalimentación mutua.'
      }
    },
    howItWorks: {
      title: 'Cómo Funciona',
      step1: {
        title: 'Describe tu Visión',
        description: 'Introduce una descripción detallada del tatuaje o diseño de uñas deseado. Incluye preferencias de estilo, temas, colores y cualquier elemento específico que desees ver.'
      },
      step2: {
        title: 'Generación por IA',
        description: 'Nuestra avanzada IA procesa tu descripción y crea múltiples opciones de diseño únicas basadas en tus especificaciones, inspirándose en miles de diseños profesionales.'
      },
      step3: {
        title: 'Refina y Perfecciona',
        description: 'Navega por los diseños generados y refínalos ajustando tu descripción o agregando más detalles hasta encontrar la coincidencia perfecta para tu visión.'
      },
      step4: {
        title: 'Descarga y Comparte',
        description: 'Descarga tus diseños favoritos para llevarlos a tu tatuador o técnico de uñas, o compártelos en redes sociales para obtener comentarios de amigos y de nuestra comunidad.'
      }
    },
    contact: {
      title: 'Contáctanos',
      subtitle: '¿Tienes preguntas, comentarios o consultas sobre asociaciones? Nos encantaría saber de ti.',
      info: {
        title: 'Información de Contacto',
        email: 'Correo:',
        support: 'Soporte:',
        business: 'Negocios:'
      },
      artists: {
        title: 'Para Artistas y Salones',
        description: '¿Eres un tatuador o salón de uñas interesado en asociarte con TattooNailGenius? Ofrecemos programas especiales para profesionales.',
        cta: 'Más Información'
      }
    }
  },
  designCard: {
    download: 'Descargar diseño',
    share: 'Compartir diseño'
  },
  footer: {
    description: 'Revolucionando el arte de tatuajes y uñas con generación de diseños impulsada por IA.',
    navigation: 'Navegación',
    legal: 'Legal',
    termsOfService: 'Términos de Servicio',
    privacyPolicy: 'Política de Privacidad',
    cookiePolicy: 'Política de Cookies',
    copyright: 'Derechos de Autor',
    contact: 'Contacto',
    email: 'Correo: info@mramoreno.tech',
    support: 'Soporte: info@mramoreno.tech',
    partnerships: 'Asociaciones: info@mramoreno.tech',
    copyright2025: '© 2025 TattooNailGenius. Todos los derechos reservados.',
    terms: 'Términos',
    privacy: 'Privacidad',
    cookies: 'Cookies'
  },
  adBanner: {
    title: 'Espacio Publicitario',
    subtitle: 'Su anuncio podría estar aquí'
  },
  auth: {
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    welcomeBack: 'Bienvenido de Nuevo',
    createAccount: 'Crear una Cuenta',
    signInSubtitle: 'Inicia sesión para acceder a tus diseños guardados y perfil',
    signUpSubtitle: 'Únete a nuestra comunidad para guardar y compartir tus diseños generados por IA',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    forgotPassword: '¿Olvidaste tu Contraseña?',
    signingIn: 'Iniciando Sesión...',
    signingUp: 'Registrándose...',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    signUpSuccess: 'Cuenta Creada Exitosamente',
    checkEmail: 'Por favor, revisa tu correo electrónico para verificar tu cuenta.'
  },
  profile: {
    title: 'Tu Perfil',
    personalInfo: 'Información Personal',
    email: 'Correo Electrónico',
    username: 'Nombre de Usuario',
    emailCannotBeChanged: 'La dirección de correo electrónico no puede ser cambiada',
    updateProfile: 'Actualizar Perfil',
    updating: 'Actualizando...',
    updateSuccess: 'Perfil actualizado exitosamente',
    favoriteDesigns: 'Diseños Favoritos',
    yourDesigns: 'Tus Diseños',
    noFavorites: 'Aún no has guardado ningún diseño',
    noDesigns: 'Aún no has creado ningún diseño',
    browseGallery: 'Navega por la galería y haz clic en el ícono de corazón para guardar los diseños que te gusten',
    createSome: 'Intenta crear algunos diseños utilizando nuestro generador de IA'
  }
};